<div class="pb-4">
  <div class="housing-2__content-wrapper-element">
    <h2>Расположение</h2>
    <p>Укажите адрес и убедитесь, что точка окажется в правильном месте.
      Если необходимо, точку можно перемещать мышью. При публикации именно
    эти точка на карте и адрес будут показываться на объекте.</p>

    <div [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          <app-input-get-address
            formControlName="address"
            [required]="true">
            Адрес
          </app-input-get-address>
        </div>
      </div>
    </div>

    @if (form.value['address'].label) {
      <div class="row">
        <div class="col-md-12 d-none">
          <div class="form__group">
            <div class="form__input">
              <input class="input" name="city" [(ngModel)]="form.value['address'].city" placeholder="Город">
            </div>
          </div>
        </div>
        @if (districts) {
          <div [formGroup]="form" class="col-md-12" [class.d-none]="without_districts">
            <app-material-select2 [caption]="'Административный округ'" formControlName="city_admin_area_id">
              <option [value]="''">-- Не выбрано --</option>
              @for (obj of districts; track obj) {
                <optgroup label = "{{obj.caption}}">
                  @for (el of obj.areas; track el) {
                    <option [value]="el.id">
                    {{el.caption}} - {{obj.short_caption}}</option>
                  }
                </optgroup>
              }
            </app-material-select2>
          </div>
        }
        <div class="col-md-12 d-none">
          <div class="form__group">
            <div class="form__input">
              <input class="input" name="district" [(ngModel)]="form.value['address'].district" placeholder="Район">
            </div>
          </div>
        </div>
        <div class="col-md-12 d-none">
          <div class="form__group">
            <div class="form__input">
              <input class="input" name="region" [(ngModel)]="form.value['address'].region" placeholder="Регион">
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div [formGroup]="form">
    <div>
      @if (resetMapVal) {
        @if ((latitude && longitude)) {
          <div class="ya-map-container">
            <ya-map
              [center]="[latitude, longitude]"
              [zoom]="16"
              [state]="{ behaviors: ['drag', 'multiTouch', 'dblClickZoom'], controls: ['default'] }"
              >
              <ya-placemark
              [options]="{
                        iconLayout: 'default#image',
                        iconImageHref: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i0KHQu9C+0LlfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMiA0NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgNDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNERTFEMjU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KPC9zdHlsZT4NCjx0aXRsZT5Ba3ogLyBNYXAgLyBTaW5nbGUgUE9JPC90aXRsZT4NCjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KPGcgaWQ9IkRlc2lnbiI+DQoJPGcgaWQ9IkhvbWUtX3gyRl8tTWFwLVZpZXciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MjcuMDAwMDAwLCAtNzQzLjAwMDAwMCkiPg0KCQk8ZyBpZD0iQWt6LV94MkZfLU1hcC1feDJGXy1TaW5nbGUtUE9JIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MjcuMDAwMDAwLCA3NDMuMDAwMDAwKSI+DQoJCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTYsMEM3LjIsMCwwLDcuMiwwLDE2YzAsMTIuMSwxNC42LDI4LjksMTUuMywyOS43YzAuMiwwLjIsMC41LDAuMywwLjgsMC4zYzAuMywwLDAuNi0wLjEsMC44LTAuMw0KCQkJCUMxNy40LDQ0LjksMzIsMjguMiwzMiwxNkMzMiw3LjIsMjQuOCwwLDE2LDB6IE0xNiw4bDgsNmgtMnY4SDEwdi04SDhMMTYsOHoiLz4NCgkJPC9nPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K',
                        iconImageSize: [32, 46],
                        iconOffset: [-5, -8],
                        hasBalloon: false,
                        hasHint: false,
                        draggable: true,
                      }"
                [geometry]="[latitude, longitude]"
                (yadragend)="onPlacemarkDragYa($event)"
              ></ya-placemark>
            </ya-map>
          </div>
        }
        <!--        <osm-map [center]="[latitude, longitude]">-->
        <!--          <osm-drawer-->
        <!--            *ngIf="drawable"-->
        <!--            [polygons]="form.value['address']['advance_address_json']"-->
        <!--            (onCreate)="polygonCreate($event)">-->
      <!--          </osm-drawer>-->
      <!--          <osm-placemark-->
      <!--            *ngIf="latitude && longitude"-->
      <!--            [coordinates]="[latitude, longitude]"-->
      <!--            [draggable]="true"-->
      <!--            (drag)="onPlacemarkDrag($event)">-->
    <!--          </osm-placemark>-->
  <!--        </osm-map>-->
}
</div>
</div>

<div class="housing-2__content-wrapper-element mt-2r">
  @if (!editSubwayHighway) {
    <app-alert-danger
      [marginBottom]= "true"
    >
      <p class="mb-0">Этот раздел только для просмотра. Метро и шоссе заполняется в карточке жилого комплекса.</p>
    </app-alert-danger>
  }
  <h2 class="subway-h2">Ближайшие метро</h2>
  <p>При публикации объекта, данные станции будут использоваться при поиске.</p>
  <div [formGroup]="form">
    <field-housing-subway
      [form]="form"
      [field_name]="'subways'"
      [values]="subways"
      [isEdit]="editSubwayHighway">
    </field-housing-subway>
  </div>
</div>
<div class="housing-2__content-wrapper-element mt-2r">
  <h2 class="highway-h2">Шоссе</h2>
  <div [formGroup]="form">
    <field-housing-highway
      [form]="form"
      [field_name]="'highways'"
      [values]="highways"
      [isEdit]="editSubwayHighway">
    </field-housing-highway>
  </div>
</div>
</div>
